import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FeedbackButtonTriggeredSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type FeedbackButtonTriggeredSubscription = { __typename?: 'Subscription', feedbackButtonTriggered: string };


export const FeedbackButtonTriggered = /*#__PURE__*/ gql`
    subscription FeedbackButtonTriggered {
  feedbackButtonTriggered
}
    ` as unknown as DocumentNode<FeedbackButtonTriggeredSubscription, FeedbackButtonTriggeredSubscriptionVariables>;

          

          export const useFeedbackButtonTriggeredSubscription = (options?:SubscriptionHookOptions<FeedbackButtonTriggeredSubscription, FeedbackButtonTriggeredSubscriptionVariables>) => useSubscription(FeedbackButtonTriggered, options);

          

          export type FeedbackButtonTriggeredSubscriptionOptions = SubscriptionHookOptions<FeedbackButtonTriggeredSubscription, FeedbackButtonTriggeredSubscriptionVariables>;

          

          export type FeedbackButtonTriggeredSubscriptionResult = ReturnType<typeof useFeedbackButtonTriggeredSubscription>;

          
